import {LayerVisibility} from "../../types";
import {IApplicationState, ILayerState} from "../types";
import {Reducer} from "redux";

const toggleLayerVisibility: Reducer<IApplicationState['map']|undefined> = (state, action) => {
    let {layer, visibility} = action.payload;
    const layerState: ILayerState = {...state?.layerState};
    let mapStyle = state?.mapStyle;
    if (!mapStyle) return state;
    let layers = mapStyle.get('layers');
    const index = layers.findIndex((l: any) => l.get('source') === layer);
    let _layer = layers.get(index);
    visibility = visibility ? visibility : getVisibility(_layer);
    layerState[layer] = {...layerState[layer], visibility};
    _layer = _layer.setIn(['layout', 'visibility'], visibility);
    layers = layers.set(index, _layer);
    mapStyle = mapStyle.set('layers', layers);
    return {...state, mapStyle, layerState} as IApplicationState['map'];
}

function getVisibility (layer: any) {
    const vis = layer.get('layout').get('visibility');
    return vis === LayerVisibility.none ? LayerVisibility.visible : LayerVisibility.none;
}

export { toggleLayerVisibility };